import type { TWorkspaceJobsListParams, TWorkspaceJobsListTab } from 'app/queries/jobs/jobsKeys';

type TInput = Omit<Extract<TWorkspaceJobsListParams, { tab: 'all' }>, 'tab'> & { tab: TWorkspaceJobsListTab };

export const buildWorkspaceJobsListParams = ({ tab, status, ...base }: TInput): TWorkspaceJobsListParams =>
  tab === 'assigned' ? { ...base, tab } : { ...base, tab, status };
